import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [ButtonModule, RouterModule],
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent {
  constructor(private router: Router) {}
}
